import { Buffer } from 'buffer';

interface TokenPayload {
  [key: string]: any;
}

export const getTokenPayload = (token: string | null | undefined): TokenPayload | null => {
  if (!token) {
    return null;
  }
  const parts = token.split('.');
  if (parts.length < 2) {
    return null;
  }
  try {
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const decoded = Buffer.from(base64, 'base64').toString('utf8');
    return JSON.parse(decoded);
  } catch (error) {
    return null;
  }
};

export const extractUsuarioFromPayload = (payload: TokenPayload | null): string | null => {
  if (!payload) {
    return null;
  }
  return (
    payload.usuario ||
    payload.username ||
    payload.user ||
    payload.unique_name ||
    payload.sub ||
    null
  );
};

export const extractIdUsuarioFromPayload = (payload: TokenPayload | null): number | null => {
  if (!payload) {
    return null;
  }
  const candidate = payload.idUsuario ?? payload.nameid ?? payload.sid ?? payload.userId ?? null;
  if (candidate === null || candidate === undefined) {
    return null;
  }
  const parsed = Number(candidate);
  return Number.isNaN(parsed) ? null : parsed;
};
